import styles from './Modal.module.scss';
import ValidateButton from '../UI/ValidateButton';
import Close from '@src/assets/Close.png';

type ModalProps = {
    title: string;
    description: string;
    show: boolean;
    onValidate: (value: boolean) => void
}

export default function Modal({title, description, show, onValidate}: ModalProps) {
    if (!show) {
        return null;
    }
    return (
        <div className={styles.modalContainer}>
            <div className={styles.modal}>
                <div className={styles.close} onClick={() => onValidate(true)}>
                    <img src={Close} alt="Close" width={14} height={14} />
                </div>
                <p className={styles.title}>{title}</p>
                <p className={styles.description}>{description}</p>
                <div className={styles.buttonDiv}>
                    <ValidateButton title="Accepter" onClick={() => onValidate(true)} isModal/>
                </div>
            </div>
        </div>
    );
}
